import React from "react";
import styled from "styled-components";
import { goodpageText } from "../../Lang/fa/Goodpage";
import { formatPrice } from "../Functions/Price";


const PriceStyle=styled.div`
    margin: 0.5rem 0 ;
    display: flex;
    /* flex-wrap: wrap; */
    justify-content: center;
    align-items: center;
    text-align: center;
    .curency{
        justify-content: center;
        white-space: nowrap;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        span{
            /* margin:0 0.5rem; */
        }
    }
    @media screen and (max-width: 500px){
        /* padding: 0.5rem 0; */
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;
        .curency {
          /* padding: 0 0.5rem; */
         
        }
    }
                        
`

class Price extends React.Component{

    render(){
        let Price;
            if(this.props.min === null){
                Price = 'نا موجود'
            } else {
                Price = (
                    <>
                        <div className="curency" >
                            
                        {
                            this.props.max ? (
                            "از"
                            )
                            :''
                        }  
                            <span>
                                {formatPrice(this.props.min)}
                            </span>
                                {goodpageText.toman} 
                            </div>
                        <span style={{flexGrow: "1"}}></span> 
                        {
                            this.props.max ? (
                            <div className="curency">تا 
                                <span>
                                    {formatPrice(this.props.max)}
                                </span>
                                {goodpageText.toman}   
                            </div>
                            )
                            :''
                        }
                    </>
                )
            }
        return <PriceStyle className="priceStyle" style={{display: (this.props.max ? '' : 'block' )}}>{Price}</PriceStyle>
    }
}
export default Price;